module.exports = __webpack_public_path__ + "img/1492533304.ebf5f937.jpg";